import { AfterViewInit, Component, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';

const containerElementName = 'signInFinish';

@Component({ standalone: false, selector: 'sing-in-finish', template: ``, encapsulation: ViewEncapsulation.None })
export class SignInFinishWrapperComponent implements AfterViewInit {
	@ViewChild(containerElementName, { static: false }) containerRef: ElementRef;

	constructor() {
		// Empty
	}

	ngAfterViewInit(): void {
		if (isInIframe()) {
			globalThis.parent.postMessage('sign-in-finished', '*');
		}
	}
}

function isInIframe(): boolean {
	try {
		return window.self !== window.top;
	} catch {
		return true;
	}
}
